import React from 'react';
import { useNavigate } from 'react-router-dom';
import AdminSignUpModale from './AdminSignUpModale';

const AdminLoginModal = ({ onLogin, toggleSignUpModal, isAdminSignUpOpen, toggleAdminSignUp }) => {
  const navigate = useNavigate();

  const handleFormSubmit = (e) => {
    e.preventDefault();
    onLogin(); // Call the callback to close the modal
    navigate("/volunteer"); // Navigate to the desired page
  };

  return (
    <div className="flex items-center justify-center h-screen">
      <div className="relative w-full items-center flex justify-center flex-col p-8 py-12 bg-[#F6F2EF] shadow-md rounded-3xl border border-gray-200">
        <h1 className="text-2xl font-bold text-center text-[#362269] p-1 rounded-lg mb-6 w-fit">ARE YOU IN?</h1>

        <button className='absolute right-3 top-4 text-black' onClick={onLogin}>
          &#10006;
        </button>

        <form className='w-full' onSubmit={handleFormSubmit}>
          <div className="space-y-4">
            <div>
              <input
                type="text"
                placeholder="Name *"
                className="w-full px-4 py-4 bg-[#E6E6E6] outline-none rounded-2xl border-0 focus:ring-2 focus:ring-[#C6AFFF]"
              />
            </div>

            <div>
              <input
                type="password"
                placeholder="Password *"
                className="w-full px-4 py-4 bg-[#E6E6E6] outline-none rounded-2xl border-0 focus:ring-2 focus:ring-[#C6AFFF]"
              />
            </div>

            <div className="flex flex-col justify-center items-center text-center">
              <button
                type="submit"
                className="common_btn mb-4"
                style={{ backgroundColor: "#C6AFFF" }}
                onClick={() => {
                    onLogin(); // Close current modal
                    navigate("/admin/dashboard"); // Navigate to Admin Dashboard
                  }}
              >
                Log in
              </button>

              {/* <div className='flex justify-between w-full'>
                <span className='flex'>
                  Don’t have an account?{" "}
                  <button
                    type="button"
                    className="text-sm text-[#C6AFFF] hover:underline"
                    onClick={toggleSignUpModal}
                  >
                    Create Account
                  </button>
                </span>

                
              </div> */}
            </div>
          </div>
        </form>
      </div>

      {isAdminSignUpOpen && (
        <div
          className="fixed top-0 right-0 left-0 z-50 flex justify-center items-center w-full h-full bg-gray-900 bg-opacity-50"
          onClick={toggleAdminSignUp}
        >
          <div
            className="relative p-4 w-full max-w-xl max-h-full rounded-lg"
            onClick={(e) => e.stopPropagation()}
          >
            <AdminSignUpModale onLogin={toggleAdminSignUp} />
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminLoginModal;
